import classNames from 'classnames';
import * as React from 'react';

import * as styles from './Controls.css';
import { INDENT_TO_CLASS } from './constants';
import { IControlsProps } from './types';
import { Desktop, NotDesktop } from '../../../../../packages/Responsive';

export const Controls: React.FC<IControlsProps> = ({
  drawPolygon,
  help,
  zoomIn,
  zoomOut,
  geoLocation,
  isBottomHidden,
  indent = 'M',
}) => {
  return (
    <>
      <Desktop>
        <div className={classNames(styles['container'], INDENT_TO_CLASS[indent])}>
          <div className={styles['middle']} data-testid="controls-middle">
            {drawPolygon}
            {zoomIn}
            {zoomOut}
            {geoLocation && <div className={styles['geo']}>{geoLocation}</div>}
          </div>
          <div className={styles['bottom']} data-testid="controls-bottom">
            {help}
          </div>
        </div>
      </Desktop>
      <NotDesktop>
        <div className={classNames(styles['container'], styles['container--mobile'], INDENT_TO_CLASS[indent])}>
          <div className={styles['middle']} data-testid="controls-middle">
            {zoomIn}
            {zoomOut}
          </div>
          <div
            className={classNames(
              styles['bottom'],
              styles['bottom--mobile'],
              isBottomHidden && styles['bottom--hidden'],
            )}
            data-testid="controls-bottom"
          >
            {geoLocation}
            <div className={styles['layer-draw']}>{drawPolygon}</div>
          </div>
        </div>
      </NotDesktop>
    </>
  );
};

Controls.displayName = 'Controls';
